import { render, staticRenderFns } from "./visTwoNumberGrow.vue?vue&type=template&id=1812fa7e"
import script from "./visTwoNumberGrow.vue?vue&type=script&lang=js"
export * from "./visTwoNumberGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports